import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './locales/ru.json';
import en from './locales/en.json';

// Главный язык приложения задаётся переменной окружения LANGUAGE
// (во фронтенд-сборку прокидывается как REACT_APP_LANGUAGE). По умолчанию — русский.
const SUPPORTED = ['ru', 'en'];
const envLang = (process.env.REACT_APP_LANGUAGE || 'ru').toLowerCase();
export const LANGUAGE = SUPPORTED.includes(envLang) ? envLang : 'ru';

// Локаль для форматирования дат/времени
export const DATE_LOCALE = LANGUAGE === 'ru' ? 'ru-RU' : 'en-US';

// Платежи (YooKassa) доступны только в русской версии.
// В остальных версиях весь связанный с оплатой UI скрыт.
export const PAYMENTS_ENABLED = LANGUAGE === 'ru';

i18n.use(initReactI18next).init({
  resources: {
    ru: { translation: ru },
    en: { translation: en },
  },
  lng: LANGUAGE,
  fallbackLng: 'ru',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
